import { render, staticRenderFns } from "./AvanzaContenitoreAlt.vue?vue&type=template&id=7aaa5b93&"
import script from "./AvanzaContenitoreAlt.vue?vue&type=script&lang=js&"
export * from "./AvanzaContenitoreAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports